
// --- Vue & Template imports ---
import { Component, Vue} from 'vue-property-decorator';

// --- Models ---
import { Adjustment, AdjustmentHeader } from '@/models/Route.model';

// --- Services ---
import AppService from '@/services/app';
import CustomerService from '@/services/customer';
import RouteAjustmentService from '@/services/routeAdjustment';

// --- Third Party ---
import dayjs from 'dayjs';

@Component
export default class SearchRateAdjustments extends Vue {

  // used by Filter Area
  searchCustomerId: number = 0;
  startDatePicker: boolean = false;
  startDate: string = '';
  endDatePicker: boolean = false;
  endDate: string = '';

  searchClicked: boolean = false;

  searchResults: AdjustmentHeader[] = [];

  clickedItem: AdjustmentHeader = {
    id: 0,
    customerId: 0,
    customerName: '',
    customerCode: '',
    effectiveDate: '',
    amount: '',
    adjustUp: false,
    description: '',
    count: 0,
    applied: false,
  };

  showViewDialog: boolean = false;
  isViewLoading: boolean = true;
  displayRoutes: Adjustment[] = [];

  rules = {
    required: (value: string) => !!value || '',
  };

  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: 'Date',
          value: 'effectiveDate',
        },
        {
          text: 'Client',
          value: 'customerCode',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Amount',
          value: 'amount',
          align: 'right',
        },
        {
          text: 'Type',
          value: 'adjustUp',
        },
        {
          text: 'Count',
          value: 'count',
        },
        {
          text: 'Approved',
          value: 'approved',
        },
        {
          text: 'Applied',
          value: 'applied',
        },
        {
          sortable: false,
          text: '',
          value: 'action',
          align: 'end',
        },
      ];
    }

    routeHeaders() {
      return [
        {
          text: 'From',
          value: 'from',
        },
        {
          text: 'To',
          value: 'to',
        },
        {
          text: 'KM',
          value: 'routeKm',
        },
        {
          text: 'Old Rate',
          value: 'oldRate',
          align: 'right',
        },
        {
          text: 'Difference',
          value: 'difference',
          align: 'right',
        },
        {
          text: 'New Rate',
          value: 'newRate',
          align: 'right',
        },
        {
          text: 'Type',
          value: 'rateType',
          align: 'right',
        },
      ];
    }

    async beforeMount() {
      await CustomerService.listAll(false);

      this.resetSearch();
    }

    canSearch() {
      return this.searchCustomerId > 0 || (this.startDate && this.startDate.length > 0) ||(this.endDate && this.endDate.length > 0);
    }

    resetSearch() {
      this.searchResults = [];

      this.searchCustomerId = 0;
      this.startDatePicker = false;
      this.startDate = dayjs().startOf('month').format('YYYY-MM-DD');
      this.endDatePicker = false;
      this.endDate = dayjs().format('YYYY-MM-DD');

      if (this.$refs.searchForm) {
        (this.$refs.searchForm as any).resetValidation();
      }
    }

    async search() {
      try {
        this.searchClicked = true;

        const response = await RouteAjustmentService.search({ params: {
          customerId: this.searchCustomerId,
          startDate: this.startDate,
          endDate: this.endDate,
        }});

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
            this.searchResults = [];
          } else {
            this.searchResults = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('Search_RateAdjustments.vue - search - 604 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.searchClicked = false;
      }
    }
  // #endregion

  // #region Functions required for the View Dialog
    async viewRoutesToAdjust(item: AdjustmentHeader) {
      this.clickedItem = item;
      this.showViewDialog = true;

      // go fetch the relevant rates
      try {
        this.isViewLoading = true;

        const response = await RouteAjustmentService.listAdjustmentsByHeader({ params: {
          headerId: this.clickedItem.id,
        }});

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            this.displayRoutes = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('Search_RateAdjustments.vue - viewRoutesToAdjust - 642 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.isViewLoading = false;
      }
    }
  // #endregion

}
